import React from 'react';
import { CloseIcon } from '@assets/icons';
import { ConfirmationState } from '@assets/images';
import { Box, Button, Flex, Text } from '@chakra-ui/react';

export default function ConfirmModal({
    onConfirmClose,
    handleConfirmYes,
    title = 'Batal membuat promotion claim?',
    desc = 'Data yang telah dituliskan akan hilang, perlu melakukan pengisian ulang untuk membuat promotion claim.',
    btnLabelYes = 'Ya, batal',
    btnLabelNo = 'Kembali',
    ...props
}) {
    return (
        <Box px={'40px'} textAlign={'center'} position={'relative'} {...props}>
            <Button onClick={onConfirmClose} variant={'unstyled'} position={'absolute'} right={'0'}>
                <CloseIcon fontSize={'px'} />
            </Button>
            <Flex justifyContent={'center'}>
                <ConfirmationState />
            </Flex>
            <Text fontWeight={'600'} fontSize={'24px'}>
                {title}
            </Text>
            <Text>{desc}</Text>
            <Flex gap={'12px'} justifyContent={'center'} mt={'40px'}>
                <Button onClick={onConfirmClose} variant="outline" px={'52px'}>
                    {btnLabelNo}
                </Button>
                <Button onClick={handleConfirmYes} px={'52px'}>
                    {btnLabelYes}
                </Button>
            </Flex>
        </Box>
    );
}
